import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { PBNTransport } from "src/app/transports/pbn";
import { PBN } from "src/app/types/PBN";

const usePBNOptions = (isPrivate?: boolean, inicialRequest = true) => {
    const [PBNOptions, setPBNOptions] = useState<Array<SimpleFormSelectOption>>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    let params: any = {
        isActive: 1,
    };
    if (typeof isPrivate === "boolean") {
        params = {
            ...params,
            isPrivate: isPrivate ? 1 : 0,
        };
    }

    const fetch = () => {
        setLoading(true);
        PBNTransport.list(params)
            .then((res) =>
                setPBNOptions(
                    res.map((pbn: PBN) => ({
                        value: pbn.id,
                        label: pbn.name,
                    }))
                )
            )
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };
    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        if (inicialRequest) fetch();
    }, []);

    return { PBNOptions, refresh, loading, error };
};

export default usePBNOptions;
